// src/data/featuresDept.js
export const FEATURES_DEPT = [
  {
    id: "gps",
    title: "Zentra GPS",
    blurb:
      "Gestión de flotas en tiempo real desde web y app móvil. controla y monitorea tus vehículos 24/7.",
    bullets: [
      {
        strong: "Monitoreo en tiempo real:",
        text: "posición, velocidad, historial y reproducción de rutas.",
      },
      {
        strong: "Alertas y geocercas:",
        text: "entradas/salidas, exceso de velocidad, batería y desconexión.",
      },
      {
        strong: "Corte remoto de motor:",
        text: "apagado seguro bajo autorización para casos específicos.",
      },
      {
        strong: "Reportes y estadísticas:",
        text: "kilometraje, tiempos detenidos, uso y mantenimientos.",
      },
    ],
    art: "blue",
  },
  {
    id: "sistemas",
    title: "Zentra Sistemas",
    blurb:
      "Desarrollamos sistemas web y websites de alto rendimiento a la medida de tu negocio.",
    bullets: [
      {
        strong: "Sistemas y APIs a medida:",
        text: "portales, paneles internos, ERPs/CRMs y microservicios.",
      },
      {
        strong: "Integraciones:",
        text: "pagos, facturación electrónica, webhooks y servicios de terceros.",
      },
      {
        strong: "UX/UI + performance:",
        text: "interfaces modernas, SEO técnico y tiempos de carga optimizados.",
      },
      {
        strong: "Operación continua:",
        text: "DevOps, CI/CD, observabilidad y soporte evolutivo.",
      },
    ],
    art: "black",
  },
  {
    id: "pos",
    title: "Zentra POS",
    blurb:
      "Sistema simple para tu negocio. Emite boletas, controla inventario y revisa reportes en minutos.",
    bullets: [
      {
        strong: "Boleta y factura:",
        text: "emisión rápida de documentos para tus ventas diarias.",
      },
      {
        strong: "Inventario fácil:",
        text: "controla productos, stock y movimientos de forma simple.",
      },
      {
        strong: "Reportes en minutos:",
        text: "revisa ventas, ingresos y rendimiento de tu negocio.",
      },
      {
        strong: "Gestión simple:",
        text: "ideal para comercios, minimarkets, restaurantes y pymes.",
      },
    ],
    art: "green",
  },
];